import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const FileDocument = createSvgIcon(
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 10H7V12H10V10Z" fill="currentColor" />
    <path d="M10 13H7V15H10V13Z" fill="currentColor" />
    <path d="M10 16H7V18H10V16Z" fill="currentColor" />
    <path d="M17 10H12V18H17V10Z" fill="currentColor" />
    <path
      d="M16.414 1H5C4.46957 1 3.96086 1.21071 3.58579 1.58579C3.21071 1.96086 3 2.46957 3 3V21C3 21.5304 3.21071 22.0391 3.58579 22.4142C3.96086 22.7893 4.46957 23 5 23H19C19.5304 23 20.0391 22.7893 20.4142 22.4142C20.7893 22.0391 21 21.5304 21 21V5.586L16.414 1ZM5 21V3H15V7H19V21H5Z"
      fill="currentColor"
    />
  </svg>,
  'FileDocument'
);
